import {
    Fragment,
    useState,
    useEffect,
    useRef,
    useImperativeHandle,
    forwardRef,
    React,
    useCallback,
} from "react";
import { useSelector } from "react-redux";
import { GridMetaData_Format } from "../../../../../Helper/Services";
import { GetCategoryList, GetDateTypeList, GetStringTypeList } from "../../../../../Helper/WidgetDataCommon";
import GetMetaData from "../../../../../Helper/Services";
import DataSectionSettings from "../../../../UI/TemplateControls/DataSection";
import WidgetTitleControl from "../../../../UI/TemplateControls/WidgetTitleControl";
import SelectField from "../../../../UI/TemplateControls/SelectField";
import { GetValueList } from "../../../../../Helper/WidgetDataCommon";
import { DataSectionObject } from "../../../../../Helper/CommonModel";
import SharedService from "../../../../../Helper/SharedService";

const TicketWidgetTemplate = forwardRef((props, ref) => {
    const [showSettingsPanel, setShowSettingsPanel] = useState(true);
    const [widgetContentPanel, setWidgetContentPanel] = useState(false);
    const [titleContentPanel, setTitleContentPanel] = useState(false);
    const [dtSourceItems, setDtSourceItems] = useState([]);
    const [title, setTitle] = useState("Ticket Widget");
    const [shortTitle, setShortTitle] = useState("Ticket Widget");
    const sessionId = useSelector((state) => state.login.sessionId);
    const [ddlList, setDdlList] = useState([]);
    const [ddlStrList, setDdlStrList] = useState([]);
    const [ddlDateList, setDdlDateList] = useState([]);
    const [getNumValues, setGetNumValues] = useState([]);
    const [titleIsValid, setTitleIsValid] = useState(true);
    const [shortTitleIsValid, setShortTitleIsValid] = useState(true);
    const dataSection = useRef(DataSectionObject);
    const dataSectionRef = useRef();
    const [topLeftLabel, setTopLeftLabel] = useState({ value: "", isValid: true });
    const [actualHoursLabel, setActualHoursLabel] = useState({ value: "", isValid: true });
    const [imagePath, setImagePath] = useState({ value: "", isValid: true });
    const [username, setUsername] = useState({ value: "", isValid: true });
    const [titleText, setTitleText] = useState({ value: "", isValid: true });
    const [completedText, setCompletedText] = useState({ value: "", isValid: true });
    const [openedText, setOpenedText] = useState({ value: "", isValid: true });
    const [promisedText, setPromisedText] = useState({ value: "", isValid: true });
    const [subTitleText, setSubTitleText] = useState({ value: "", isValid: true });
    const [subTitle1Text, setSubTitle1Text] = useState({ value: "", isValid: true });
    const [viewMode, setViewMode] = useState({ value: "Portrait", isValid: true });
    const [numberOfTickets, setNumberOfTickets] = useState({ value: 0, isValid: true, errorMsg: "Please enter a value between 1 and 5" });
    const [preserveTicketViewChanges, setPreserveTicketViewChanges] = useState({ value: 0, isValid: true, errorMsg: "Required" });
    const [header, setHeader] = useState({ value: "", isValid: true, errorMsg: "Required" });
    const [sortingBy, setSortingBy] = useState({ value: "", isValid: true, errorMsg: "Required" });
    const [sortDirection, setSortDirection] = useState({ value: "asc", isValid: true });
    const [openTicketsPosition, setOpenTicketsPosition] = useState({ value: "bottom", isValid: true });
    const [percentageOfTarget, setPercentageOfTarget] = useState({ value: "", isValid: true });



    useEffect(() => {
        if (
            props.dataSources !== undefined &&
            Object.keys(props.dataSources.Reports).length !== 0
        ) {
            const _items = Object.entries(props.dataSources.Reports)
                .filter((item) => {
                    if (item[1] === "Generic Table") {
                        return true;
                    }
                })
                .map((item) => item[0]);
            setDtSourceItems(_items);
        }

        if (
            props.dataSources !== undefined &&
            props.isEdit === true &&
            props.settings !== undefined &&
            props.settings["reports"] !== undefined
        ) {
            getMetaData(props.settings["reports"], props.settings["connection"]);
            setTitle(props.settings["Title"]);
            setShortTitle(props.settings["ShortTitle"]);
            setTopLeftLabel({
                value: props.settings["topLeftLabel"],
                isValid: true,
            });
            setActualHoursLabel({
                value: props.settings["actualHoursLabel"] || "",
                isValid: true,
            });
            setImagePath({ value: props.settings["imagePath"], isValid: true });
            setUsername({ value: props.settings["username"], isValid: true });
            setTitleText({ value: props.settings["titleText"], isValid: true });
            setCompletedText({ value: props.settings["completedText"], isValid: true });
            setSubTitleText({ value: props.settings["subTitleText"], isValid: true });
            setSubTitle1Text({ value: props.settings["subTitle1Text"], isValid: true });
            setNumberOfTickets({ value: props.settings["numberOfTickets"], isValid: true });
            setPreserveTicketViewChanges({ value: props.settings["preserveTicketViewChanges"], isValid: true });
            setHeader({ value: props.settings["headerText"], isValid: true });
            setSortingBy({ value: props.settings["sortingBy"], isValid: true });
            setSortDirection({ value: props.settings["sortDirection"], isValid: true });
            setOpenTicketsPosition({ value: props.settings["openTicketsPosition"], isValid: true });
            setOpenedText({ value: props.settings["openedText"], isValid: true });
            setPromisedText({ value: props.settings["promisedText"], isValid: true });
            setPercentageOfTarget({ value: props.settings["percentageOfTarget1"], isValid: true });
        }
    }, [props.dataSources, props.settings]);

    useImperativeHandle(ref, () => ({
        GetValidateData() {
            const getVaildForm = validateForm();
            if (getVaildForm) {
                return {
                    formIsValid: getVaildForm,
                    data: {
                        Filter: dataSection.current.filterName,
                        FilterId: dataSection.current.filterDetails.filterid,
                        IsSharedFilter: dataSection.current.filterDetails.filterid,
                        OriginalUserId: dataSection.current.filterDetails.originaluserid,
                        ShortTitle: shortTitle,
                        Title: title,
                        topLeftLabel: topLeftLabel.value,
                        actualHoursLabel: actualHoursLabel.value,
                        imagePath: imagePath.value,
                        username: username.value,
                        titleText: titleText.value,
                        subTitleText: subTitleText.value,
                        subTitle1Text: subTitle1Text.value,
                        completedText: completedText.value,
                        numberOfTickets: numberOfTickets.value,
                        connection: dataSection.current.connectionName,
                        reports: dataSection.current.dataSourceName,
                        preserveTicketViewChanges: preserveTicketViewChanges.value,
                        headerText: header.value,
                        sortingBy: sortingBy.value,
                        sortDirection: sortDirection.value,
                        openTicketsPosition: openTicketsPosition.value,
                        openedText: openedText.value,
                        promisedText: promisedText.value,
                        percentageOfTarget1: percentageOfTarget.value,
                    },
                };
            } else {
                return {
                    formIsValid: getVaildForm,
                };
            }
        },
    }));

    const onSettingsClicked = (val) => {
        if (val) {
            setShowSettingsPanel(val);
        } else {
            setShowSettingsPanel(!showSettingsPanel);
        }
        setWidgetContentPanel(false);
        setTitleContentPanel(false);
    };

    const onWidgetContentClicked = (val) => {
        if (val) {
            setWidgetContentPanel(val);
        } else {
            setWidgetContentPanel(!widgetContentPanel);
        }
        setShowSettingsPanel(false);
        setTitleContentPanel(false);
    };

    const onTitleContentPanelClicked = (val) => {
        if (val) {
            setTitleContentPanel(val);
        } else {
            setTitleContentPanel(!titleContentPanel);
        }
        setWidgetContentPanel(false);
        setShowSettingsPanel(false);
    };

    const OnTitleChangeHandler = (event) => {
        setTitle(event.target.value);
    };

    const OnShortTitleChangeHandler = (event) => {
        setShortTitle(event.target.value);
    };

    const onChangeHeader = (event) => {
        setHeader({ ...header, value: event.target.value, isValid: true });
    };

    const onChangeViewMode = (event) => {
        setViewMode({ ...viewMode, value: event.target.value, isValid: true });
    };
    const onChangeImagePath = (event) => {
        setImagePath({ ...imagePath, value: event.target.value, isValid: true });
    };
    const onChangeTopLeftLabel = (event) => {
        setTopLeftLabel({ ...topLeftLabel, value: event.target.value, isValid: true });
    };
    const onChangeActualHoursLabel = (event) => {
        setActualHoursLabel({ ...actualHoursLabel, value: event.target.value, isValid: true });
    };
    const onChangeUsername = (event) => {
        setUsername({ ...username, value: event.target.value, isValid: true });
    };
    const onChangeTitleText = (event) => {
        setTitleText({ ...titleText, value: event.target.value, isValid: true });
    };

    const onChangeCompletedText = (event) => {
        setCompletedText({ ...completedText, value: event.target.value, isValid: true });
    };

    const onChangeSubTitleText = (event) => {
        setSubTitleText({ ...subTitleText, value: event.target.value, isValid: true });
    };
    const onChangeSubTitle1Text = (event) => {
        setSubTitle1Text({ ...subTitle1Text, value: event.target.value, isValid: true });
    };
    const onChangeNumberOfTickets = (event) => {
        setNumberOfTickets({ ...numberOfTickets, value: event.target.value, isValid: true });
    }

    const onChangePreserveTicketViewChanges = (event) => {
        setPreserveTicketViewChanges({ ...preserveTicketViewChanges, value: event.target.value, isValid: true });
    };

    const onChangeSortingBy = (event) => {
        setSortingBy({ ...sortingBy, value: event.target.value, isValid: true });
    };

    const onChangeSortDirection = (event) => {
        setSortDirection({ ...sortDirection, value: event.target.value, isValid: true });
    }

    const onChangeOpenTicketsPosition = (event) => {
        setOpenTicketsPosition({ ...openTicketsPosition, value: event.target.value, isValid: true });
    };

    const onChangeOpenedText = (event) => {
        setOpenedText({ ...openedText, value: event.target.value, isValid: true });
    };

    const onChangePromisedText = (event) => {
        setPromisedText({ ...promisedText, value: event.target.value, isValid: true });
    };

    const onChangePercentageOfTarget = (event) => {
        setPercentageOfTarget({ ...percentageOfTarget, value: event.target.value, isValid: true });
    };

    const onDatasourceChangeHandler = (dataSourceVal) => {
        if (dataSourceVal !== "" && !SharedService.isGoogleSheet(dataSourceVal)) {
            getMetaData(dataSourceVal);
        }
    };

    const connectionChangeHandler = useCallback((dataSourceName, connectionName) => {
        // Handle connection change if needed
        if (SharedService.isGoogleSheet(dataSourceName)) {
            if (connectionName !== "") {
                getMetaData(dataSourceName, connectionName);
            }
        }
    }, [props.settings]);


    const getMetaData = (dataSourceVal, connection = "") => {
        GetMetaData(dataSourceVal, connection, sessionId)
            .then((json) => {
                const metaData = GridMetaData_Format(json);
                const getCategories = GetCategoryList(metaData);
                const getNumericValues = GetValueList(metaData);
                const getStringValues = GetStringTypeList(metaData);
                const getDatesValues = GetDateTypeList(metaData);
                console.log("getNumericValues", getNumericValues);
                console.log("getStringValues", getStringValues);
                console.log("getDatesValues", getDatesValues);
                setDdlList(getCategories);
                setGetNumValues(getNumericValues);
                setDdlStrList(getStringValues);
                setDdlDateList(getDatesValues);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const validateTitle = () => {
        if (title === "") {
            onTitleContentPanelClicked(true);
            setTitleIsValid(false);
            setTimeout(() => {
                setTitleIsValid(true);
            }, 3000);
            return false;
        }
        return true;
    };

    const validateShortTitle = () => {
        if (shortTitle === "") {
            onTitleContentPanelClicked(true);
            setShortTitleIsValid(false);
            setTimeout(() => {
                setShortTitleIsValid(true);
            }, 3000);
            return false;
        }
        return true;
    };

    const validateTopLeftLabel = () => {
        if (topLeftLabel.value === "") {
            onWidgetContentClicked(true);
            setTopLeftLabel({ ...topLeftLabel, isValid: false });
            setTimeout(() => {
                setTopLeftLabel({ ...topLeftLabel, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateUsername = () => {
        if (username.value === "") {
            onWidgetContentClicked(true);
            setUsername({ ...username, isValid: false });
            setTimeout(() => {
                setUsername({ ...username, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateTitleText = () => {
        if (titleText.value === "") {
            onWidgetContentClicked(true);
            setTitleText({ ...titleText, isValid: false });
            setTimeout(() => {
                setTitleText({ ...titleText, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateSubTitleText = () => {
        if (subTitleText.value === "") {
            onWidgetContentClicked(true);
            setSubTitleText({ ...subTitleText, isValid: false });
            setTimeout(() => {
                setSubTitleText({ ...subTitleText, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateSubTitle1Text = () => {
        if (subTitle1Text.value === "") {
            onWidgetContentClicked(true);
            setSubTitle1Text({ ...subTitle1Text, isValid: false });
            setTimeout(() => {
                setSubTitle1Text({ ...subTitle1Text, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateViewMode = () => {
        if (viewMode.value === "") {
            onWidgetContentClicked(true);
            setViewMode({ ...viewMode, isValid: false });
            setTimeout(() => {
                setViewMode({ ...viewMode, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateNumberOfTickets = () => {

        if (numberOfTickets.value === "") {
            onWidgetContentClicked(true);
            setNumberOfTickets({ ...numberOfTickets, isValid: false, errorMsg: "Required" });
            setTimeout(() => {
                setNumberOfTickets({ ...numberOfTickets, isValid: true, errorMsg: "" });
            }, 3000);
            return false;
        }

        if (numberOfTickets.value < 0 || numberOfTickets.value > 99) {
            onWidgetContentClicked(true);
            setNumberOfTickets({ ...numberOfTickets, isValid: false, errorMsg: "Please enter a value between 0 and 99" });
            setTimeout(() => {
                setNumberOfTickets({ ...numberOfTickets, isValid: true, errorMsg: "" });
            }, 3000);
            return false;
        }
        return true;
    };

    const validatePreserveTicketViewChanges = () => {
        if (preserveTicketViewChanges.value === "") {
            onWidgetContentClicked(true);
            setPreserveTicketViewChanges({ ...preserveTicketViewChanges, isValid: false });
            setTimeout(() => {
                setPreserveTicketViewChanges({ ...preserveTicketViewChanges, isValid: true });
            }, 3000);
            return false;
        }
        return true;
    };

    const validateForm = () => {
        const dataSectionVal = dataSectionRef.current.validateDataSection();
        dataSection.current = dataSectionVal.data;

        if (!dataSectionVal.isDataSectionValid) {
            onSettingsClicked(true);
            return false;
        }

        const isTitleValid = validateTitle();
        if (!isTitleValid) {
            return false;
        }

        const isShortTitleValid = validateShortTitle();
        if (!isShortTitleValid) {
            return false;
        }

        const isTopLeftLabelValid = validateTopLeftLabel();
        if (!isTopLeftLabelValid) {
            return false;
        }

        const isUsernameValid = validateUsername();
        if (!isUsernameValid) {
            return false;
        }

        const isTitleTextValid = validateTitleText();
        if (!isTitleTextValid) {
            return false;
        }

        const isSubTitleTextValid = validateSubTitleText();
        if (!isSubTitleTextValid) {
            return false;
        }

        const isSubTitle1TextValid = validateSubTitle1Text();
        if (!isSubTitle1TextValid) {
            return false;
        }

        const isViewModeValid = validateViewMode();
        if (!isViewModeValid) {
            return false;
        }

        const isPreserveTicketViewChangesValid = validatePreserveTicketViewChanges();
        if (!isPreserveTicketViewChangesValid) {
            return false;
        }

        const isNumberOfTicketsValid = validateNumberOfTickets();
        if (!isNumberOfTicketsValid) {
            return false;
        }


        return true;
    };

    return (
        <Fragment>
            {!props.isEdit && <hr className="style-one" />}
            <div onClick={onSettingsClicked}>
                <div style={{ float: "left", fontSize: "20px", marginTop: "-4px" }}>
                    {showSettingsPanel && "-"}
                    {!showSettingsPanel && "+"}
                </div>
                <p style={{ paddingLeft: "12px" }}>DATA</p>
            </div>
            <div
                style={{
                    paddingLeft: "10px",
                    display: showSettingsPanel ? "block" : "none",
                }}
            >
                <DataSectionSettings
                    dataSourceList={dtSourceItems}
                    dtSourceChange={onDatasourceChangeHandler}
                    ref={dataSectionRef}
                    settings={props.settings}
                    isEdit={props.isEdit}
                    connectionChange={connectionChangeHandler}
                />
            </div>
            <div onClick={onTitleContentPanelClicked}>
                <div style={{ float: "left", fontSize: "20px", marginTop: "-4px" }}>
                    {titleContentPanel && "-"}
                    {!titleContentPanel && "+"}
                </div>
                <p style={{ paddingLeft: "12px" }}>WIDGET TITLE</p>
            </div>
            <div
                style={{
                    paddingLeft: "10px",
                    display: titleContentPanel ? "block" : "none",
                }}
            >
                <WidgetTitleControl
                    titleVal={title}
                    shortTitleVal={shortTitle}
                    OnTitleChangeHandler={OnTitleChangeHandler}
                    OnShortTitleChangeHandler={OnShortTitleChangeHandler}
                    isTitleValid={titleIsValid}
                    isShortTitleValid={shortTitleIsValid}
                />
            </div>
            <div onClick={onWidgetContentClicked}>
                <div style={{ float: "left", fontSize: "20px", marginTop: "-4px" }}>
                    {widgetContentPanel && "-"}
                    {!widgetContentPanel && "+"}
                </div>
                <p style={{ paddingLeft: "12px" }}>WIDGET CONTENT</p>
            </div>
            <div
                style={{
                    paddingLeft: "12px",
                    display: widgetContentPanel ? "block" : "none",
                }}
            >
                <SelectField
                    label="Header"
                    value={header.value}
                    isValid={header.isValid}
                    onChange={onChangeHeader}
                    options={ddlList}
                />
                <SelectField
                    label="Percentage of Target"
                    value={percentageOfTarget.value}
                    isValid={percentageOfTarget.isValid}
                    onChange={onChangePercentageOfTarget}
                    options={getNumValues}
                />
                <SelectField
                    label="Target Hours"
                    value={topLeftLabel.value}
                    isValid={topLeftLabel.isValid}
                    onChange={onChangeTopLeftLabel}
                    options={getNumValues}
                />
                <SelectField
                    label="Actual Hours"
                    value={actualHoursLabel.value}
                    isValid={actualHoursLabel.isValid}
                    onChange={onChangeActualHoursLabel}
                    options={getNumValues}
                />
                <SelectField
                    label="Image (email address)"
                    value={imagePath.value}
                    isValid={imagePath.isValid}
                    onChange={onChangeImagePath}
                    options={ddlStrList}
                />
                <SelectField
                    label="Username"
                    value={username.value}
                    isValid={username.isValid}
                    onChange={onChangeUsername}
                    options={ddlStrList}
                />
                <SelectField
                    label="Title"
                    value={titleText.value}
                    isValid={titleText.isValid}
                    onChange={onChangeTitleText}
                    options={ddlStrList}
                />
                <SelectField
                    label="Subheading"
                    value={subTitleText.value}
                    isValid={subTitleText.isValid}
                    onChange={onChangeSubTitleText}
                    options={ddlStrList}
                />
                <SelectField
                    label="Subheading1"
                    value={subTitle1Text.value}
                    isValid={subTitle1Text.isValid}
                    onChange={onChangeSubTitle1Text}
                    options={ddlStrList}
                />

                <SelectField
                    label="Opened"
                    value={openedText.value}
                    isValid={openedText.isValid}
                    onChange={onChangeOpenedText}
                    options={ddlDateList}
                />

                <SelectField
                    label="Promised"
                    value={promisedText.value}
                    isValid={promisedText.isValid}
                    onChange={onChangePromisedText}
                    options={ddlDateList}
                />


                <SelectField
                    label="Completed"
                    value={completedText.value}
                    isValid={completedText.isValid}
                    onChange={onChangeCompletedText}
                    options={ddlDateList}
                />
                {/* <SelectField
                    label="View Mode"
                    value={viewMode.value}
                    isValid={viewMode.isValid}
                    onChange={onChangeViewMode}
                    options={[{ value: 'Portrait', text: 'Portrait' }, { value: 'Landscape', text: 'Landscape' }]}
                /> */}
                <p>Preserve Ticket View Changes (seconds)</p>
                <input
                    type="number"
                    name="preserveTicketViewChanges"
                    id="preserveTicketViewChanges"
                    value={preserveTicketViewChanges.value}
                    onChange={onChangePreserveTicketViewChanges}
                    min="1"
                    max="5"
                />
                <span
                    style={{
                        display: preserveTicketViewChanges.isValid ? "none" : "block",
                        color: "red",
                        paddingLeft: "5px",
                    }}
                >
                    {preserveTicketViewChanges.errorMsg}
                </span>
                <p>Max Open Ticket Count (99 = no max)</p>
                <input
                    type="number"
                    name="numberofTickets"
                    id="numberofTickets"
                    value={numberOfTickets.value}
                    onChange={onChangeNumberOfTickets}
                    min="0"
                    max="99"
                />
                <span
                    style={{
                        display: numberOfTickets.isValid ? "none" : "block",
                        color: "red",
                        paddingLeft: "5px",
                    }}
                >
                    {numberOfTickets.errorMsg}
                </span>

                <SelectField
                    label="Sort Tickets By"
                    value={sortingBy.value}
                    isValid={sortingBy.isValid}
                    onChange={onChangeSortingBy}
                    options={ddlList}
                />
                <SelectField
                    label="Sort Direction"
                    value={sortDirection.value}
                    isValid={sortDirection.isValid}
                    onChange={onChangeSortDirection}
                    options={[{ id: 'asc', text: 'Ascending' }, { id: 'desc', text: 'Descending' }]}
                />
                <SelectField
                    label="Open Tickets Position"
                    value={openTicketsPosition.value}
                    isValid={openTicketsPosition.isValid}
                    onChange={onChangeOpenTicketsPosition}
                    options={[{ id: 'top', text: 'Top | Left' }, { id: 'bottom', text: 'Bottom | Right' }]}
                />
            </div>
        </Fragment>
    );
});

export default TicketWidgetTemplate;
